<template>
  <div class="index">
    <div class="top">
      <div
        class="item"
        @click="handleNavigate('day', 0)"
      >
        <template v-for="(item, index) in top.yesterdayIncome">
          <van-field
            v-if="item.currency == 'eur' || (item.currency == 'chf' && shopInfo.supCurrency.indexOf(2) > -1) || (item.currency == 'meal' && shopInfo.supCurrency.indexOf(3) > -1) || item.currency == 'paypal'"
            :key="index"
            :label="item.currency == 'eur' ? '€' : item.currency == 'chf' ? 'CHF' : item.currency == 'meal' ? '饭票' : item.currency == 'meal' ? '饭票' : item.currency == 'paypal' ? 'ANCV' : ''"
            label-width="60px"
            :value="item.countSum || 0"
            readonly
          />
        </template>
        <p class="item-name">
          昨日收入
        </p>
      </div>
      <div
        class="item"
        @click="handleNavigate('day', 1)"
      >
        <template v-for="(item, index) in top.yesterdayOut">
          <van-field
            v-if="item.currency == 'eur' || (item.currency == 'chf' && shopInfo.supCurrency.indexOf(2) > -1) || (item.currency == 'meal' && shopInfo.supCurrency.indexOf(3) > -1)"
            :key="index"
            :label="item.currency == 'eur' ? '€' : item.currency == 'chf' ? 'CHF' : item.currency == 'meal' ? '饭票' : ''"
            label-width="60px"
            :value="item.countSum || 0"
            readonly
          />
        </template>
        <van-field 
          v-if="shopInfo.supCurrency.indexOf(2) > -1" 
          class="opacity"
        />
        <van-field 
          v-if="shopInfo.supCurrency.indexOf(3) > -1" 
          class="opacity" 
        />
        <p class="item-name">
          昨日支出
        </p>
      </div>
      <div
        class="item"
        @click="handleNavigate('month', 1)"
      >
        <template v-for="(item, index) in top.weekIncome">
          <van-field
            v-if="item.currency == 'eur' || (item.currency == 'chf' && shopInfo.supCurrency.indexOf(2) > -1) || (item.currency == 'meal' && shopInfo.supCurrency.indexOf(3) > -1) || item.currency == 'paypal'"
            :key="index"
            :label="item.currency == 'eur' ? '€' : item.currency == 'chf' ? 'CHF' : item.currency == 'meal' ? '饭票' : item.currency == 'paypal' ? 'ANCV' : ''"
            label-width="60px"
            :value="item.countSum || 0"
            readonly
          />
        </template>
        <p class="item-name">
          本周收入
        </p>
      </div>
      <div
        class="item"
        @click="handleNavigate('month', 1)"
      >
        <template v-for="(item, index) in top.weekOut">
          <van-field
            v-if="item.currency == 'eur' || (item.currency == 'chf' && shopInfo.supCurrency.indexOf(2) > -1) || (item.currency == 'meal' && shopInfo.supCurrency.indexOf(3) > -1)"
            :key="index"
            :label="item.currency == 'eur' ? '€' : item.currency == 'chf' ? 'CHF' : item.currency == 'meal' ? '饭票' : ''"
            label-width="60px"
            :value="item.countSum || 0"
            readonly
          />
        </template>
        <van-field 
          v-if="shopInfo.supCurrency.indexOf(2) > -1" 
          class="opacity"
        />
        <van-field 
          v-if="shopInfo.supCurrency.indexOf(3) > -1" 
          class="opacity" 
        />
        <p class="item-name">
          本周支出
        </p>
      </div>
      <template v-if="isIncomeOut == 1">
        <div
          class="item"
          @click="handleNavigate('month', 2)"
        >
          <template v-for="(item, index) in top.monthIncome">
            <van-field
              v-if="item.currency == 'eur' || (item.currency == 'chf' && shopInfo.supCurrency.indexOf(2) > -1) || (item.currency == 'meal' && shopInfo.supCurrency.indexOf(3) > -1) || item.currency == 'paypal'"
              :key="index"
              :label="item.currency == 'eur' ? '€' : item.currency == 'chf' ? 'CHF' : item.currency == 'meal' ? '饭票' : item.currency == 'paypal' ? 'ANCV' : ''"
              label-width="60px"
              :value="item.countSum || 0"
              readonly
            />
          </template>
          <p class="item-name">
            本月收入
          </p>
        </div>
        <div
          class="item"
          @click="handleNavigate('month', 2)"
        >
          <template v-for="(item, index) in top.monthIOut">
            <van-field
              v-if="item.currency == 'eur' || (item.currency == 'chf' && shopInfo.supCurrency.indexOf(2) > -1) || (item.currency == 'meal' && shopInfo.supCurrency.indexOf(3) > -1)"
              :key="index"
              :label="item.currency == 'eur' ? '€' : item.currency == 'chf' ? 'CHF' : item.currency == 'meal' ? '饭票' : ''"
              label-width="60px"
              :value="item.countSum || 0"
              readonly
            />
          </template>
          <van-field 
            v-if="shopInfo.supCurrency.indexOf(2) > -1" 
            class="opacity"
          />
          <van-field 
            v-if="shopInfo.supCurrency.indexOf(3) > -1" 
            class="opacity" 
          />
          <p class="item-name">
            本月支出
          </p>
        </div>
      </template>
    </div>
    <van-button
      class="btn"
      type="info"
      block
      @click="handleNavigate('day/add')"
    >
      记录本日收支
    </van-button>

    <van-button
      class="btn"
      type="danger"
      block
      @click="logout"
    >
      退出登陆
    </van-button>
  </div>
</template>
<script>
/* global process */
import { GetSumCount } from '@/api/report';
export default {
  name: "Index",
  data() {
    return {
        shopInfo: {},
        isIncomeOut: '',
        top: {
            dayIncome: [],
            dayOut: [],
            monthIncome: [],
            monthIOut: [],
            weekIncome: [],
            weekOut: [],
            yearIncome: [],
            yearOut: [],
        },
    };
  },
  mounted(){
    const shopInfo = localStorage.getItem("sushiWechatShopInfo");
    this.isIncomeOut = localStorage.getItem("isIncomeOut");
    if(!shopInfo){
      this.$toast('无店铺信息,请重新登录');
      window.location.href = (process.env.VUE_APP_PUBLIC_PATH || '/') + '#/login';
      localStorage.setItem('sushiWechatToken','');
      localStorage.setItem('sushiWechatShopInfo','');
      return
    }
    this.shopInfo = JSON.parse(shopInfo)
    this.getSumCount();
  },
  methods: {
    getSumCount(){
      GetSumCount().then(res => {
        Object.assign(this.top, res)
      })
    },
    handleNavigate(name, type){
      this.$router.push({path: `/${name}`, query: { type }})
    },
    logout(){
      window.location.href = (process.env.VUE_APP_PUBLIC_PATH || '/') + '#/login';
      localStorage.setItem('sushiWechatToken','');
      localStorage.setItem('sushiWechatShopInfo','');
    }
  }
};
</script>
<style lang="scss" scope>
  .index{
    padding: 0 20px;
    .btn{
      margin-top: 40px;
    }
  }
  .top{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .item{
      width: 48%;
      border: 1px solid #ebedf0;
      margin-top: 40px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

    }
    .item-name{
      font-size: 12px;
      text-align: center;
      padding: 20px 0;
      align-self: flex-end;
    }
    .opacity{
      opacity: 0;
    }
  }
  .van-cell::after{
    border: none;
  }
</style>
